<template>

  <modalo
    :title="title"
    type="long"
    @hideModal="hideModal()">

    <Table
      v-if="dataChart"
      :dataChart="dataChart"
      :page="page"
      :sort="sort"
      @changePage="changePage"
      height="100%"
      :exportModule="dashcomponent.module"
      :exportSelect="null"
      :exportFilters="filters" />

  </modalo>

</template>

<script>
import Table from './Table'
import Export from './Export'

export default {
  name: 'Expand',
  components: {
    Table,
    Export
  },
  props: {
    dashcomponent: {
      type: Object
    },
    title: {
      type: String
    },
    filters: {
      type: Array
    }
  },
  data () {
    return {
      dataChart: null,
      page: 1,
      sort: null,
      showExport: false
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    hideModal () {
      this.$emit('hideModal')
    },
    loadData () {
      this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/reporting', {
        filters: this.filters,
        type: 'table',
        select: null,
        module: this.dashcomponent.module,
        page: this.page,
        sort: this.sort
      }).then(result => {
        this.dataChart = result.data
      })
    },
    changePage (n) {
      this.page = n
      this.loadData()
    },
    changeSort (n) {
      this.sort = n
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ReportChart/Expand.vue